import { useState } from 'react';
import _ from 'lodash';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import CircularProgress from '@mui/material/CircularProgress';
import COLORS from 'shared/constants/colors';

const CustomImage = ({
  src,
  alt,
  aspectRatio = 1,
  imageStyle,
  onClick,
}) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);
  const ratio = typeof aspectRatio === 'number' ? aspectRatio : 1;

  return (
    <Box
      onClick={() => _.isFunction(onClick) && onClick()}
      sx={{
        position: 'relative',
        width: '100%',
        paddingTop: `${(1 / ratio) * 100}%`,
        backgroundColor: 'inherit',
        cursor: onClick ? 'pointer' : 'default',
        overflow: 'hidden',
      }}
    >
      {!loaded && !error && (
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CircularProgress sx={{ color: COLORS.BLUE }} />
        </Box>
      )}
      {error ? (
        <Skeleton
          variant="rectangular"
          sx={{ position: 'absolute', inset: 0, width: '100%', height: '100%' }}
        />
      ) : (
        <Box
          component="img"
          src={src}
          alt={alt}
          onLoad={() => setLoaded(true)}
          onError={() => setError(true)}
          sx={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            opacity: loaded ? 1 : 0,
            transition: 'opacity 0.2s ease',
            ...imageStyle,
          }}
        />
      )}
    </Box>
  );
};

export default CustomImage;
